module.exports = __webpack_public_path__ + "media/npc_dota_hero_muerta.01fe21e5.webm";